import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4 dark-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-md-3 legal-info align-items-center" }
const _hoisted_6 = { class: "icon-link" }
const _hoisted_7 = { class: "icon-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"col-md-6 text-md-start\" data-v-7d9bd85d><p class=\"mb-0\" data-v-7d9bd85d>© 2025 Crafting Systems GmbH. Alle Rechte vorbehalten.</p></div><div class=\"col-md-3 justify-content-end social-icons\" data-v-7d9bd85d><a href=\"https://www.linkedin.com/company/100260640/\" target=\"_blank\" class=\"social-link\" data-v-7d9bd85d><i class=\"fab fa-linkedin\" data-v-7d9bd85d></i></a></div>", 2)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-gavel icon" }, null, -1)),
              _createVNode(_component_router_link, {
                to: "/impressum",
                class: "label"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("Impressum")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-shield-alt icon" }, null, -1)),
              _createVNode(_component_router_link, {
                to: "/datenschutz",
                class: "label"
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("Datenschutz")
                ])),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}